import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter, Link } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import { WarningModal } from "../../components/Modal";
import {
  REQPushNotiList,
  DELPushNotiCampaign,
  CleanUpPushNotiList
} from "./redux/actions";
import { PUSH_HISTORY_URL } from "../PushNotiCompose/config";
import "./style.scss";

const STATUS_FILTERS = [
  { value: "ALL", label: "ทั้งหมด" },
  { value: "SENT", label: "ส่งแล้ว" },
  { value: "SCHEDULED", label: "ตั้งเวลาไว้" },
  { value: "DRAFT", label: "ฉบับร่าง" },
  { value: "FAILED", label: "ล้มเหลว" }
];

const STATUS_LABEL = {
  SENT: "ส่งแล้ว",
  PARTIAL: "ส่งบางส่วน",
  FAILED: "ล้มเหลว",
  SCHEDULED: "ตั้งเวลาไว้",
  DRAFT: "ฉบับร่าง",
  SENDING: "กำลังส่ง"
};

const formatDate = value => {
  if (!value) {
    return "-";
  }
  const date = new Date(value);
  return isNaN(date.getTime()) ? "-" : date.toLocaleString("th-TH");
};

function PushNotiList(props) {
  const {
    REQPushNotiList,
    DELPushNotiCampaign,
    CleanUpPushNotiList,
    REQStrPushNotiList,
    PushNotiList,
    RemoteAvailable,
    history
  } = props;

  const [oFilter, SETxFilter] = useState("ALL");
  const [oDetail, SETxDetail] = useState(null);
  const [oDeleteId, SETxDeleteId] = useState(null);

  useEffect(() => {
    REQPushNotiList();
    return () => {
      CleanUpPushNotiList();
    };
  }, []);

  const campaigns = (PushNotiList || []).filter(campaign => {
    if (oFilter === "ALL") {
      return true;
    }
    if (oFilter === "SENT") {
      return campaign.status === "SENT" || campaign.status === "PARTIAL";
    }
    return campaign.status === oFilter;
  });

  return (
    <Fragment>
      {REQStrPushNotiList ? (
        <div className="funds-list-progress">
          <CircularProgress />
          <p className="funds-list-progress-text">กำลังโหลดรายการแคมเปญ...</p>
        </div>
      ) : null}

      <div className="push-list-container">
        <div className="push-list-topbar">
          <div>
            <h2 className="push-list-heading">การแจ้งเตือน</h2>
            <p className="push-list-subheading">
              แคมเปญ push notification ที่สร้างจากหน้านี้
            </p>
          </div>
          <Link className="push-list-create" to="/PushNoti_Compose">
            <span style={{ paddingRight: 8 }}>+</span>สร้างการแจ้งเตือน
          </Link>
        </div>

        {!RemoteAvailable ? (
          <div className="push-list-banner">
            รายการนี้อ่านจากเบราว์เซอร์เครื่องนี้เท่านั้น — be-notification ยังไม่มี endpoint
            เก็บประวัติแคมเปญ (ตั้งค่า <code>REACT_APP_API_PUSH_HISTORY_URL</code>{" "}
            เมื่อ backend พร้อม{PUSH_HISTORY_URL ? " — ตอนนี้ตั้งไว้แล้วแต่เรียกไม่สำเร็จ" : ""})
          </div>
        ) : null}

        <div className="push-list-filters">
          {STATUS_FILTERS.map(filter => (
            <button
              type="button"
              key={filter.value}
              className={
                oFilter === filter.value ? "push-list-filter active" : "push-list-filter"
              }
              onClick={() => SETxFilter(filter.value)}
            >
              {filter.label}
            </button>
          ))}
        </div>

        <div className="push-list-table-wrap">
          <table className="push-list-table">
            <thead>
              <tr>
                <th>ชื่อแคมเปญ</th>
                <th>สถานะ</th>
                <th>เป้าหมาย</th>
                <th>ผลการส่ง</th>
                <th>สร้างโดย</th>
                <th>เวลา</th>
                <th>จัดการ</th>
              </tr>
            </thead>
            <tbody>
              {campaigns.length === 0 ? (
                <tr>
                  <td colSpan={7} className="push-list-empty">
                    ยังไม่มีแคมเปญ
                  </td>
                </tr>
              ) : (
                campaigns.map(campaign => (
                  <tr key={campaign.id}>
                    <td>
                      <button
                        type="button"
                        className="push-list-link"
                        onClick={() => SETxDetail(campaign)}
                      >
                        {campaign.name}
                      </button>
                      <p className="push-list-subtext">{campaign.body}</p>
                    </td>
                    <td>
                      <span className={`push-list-status status-${campaign.status}`}>
                        {STATUS_LABEL[campaign.status] || campaign.status}
                      </span>
                    </td>
                    <td>
                      {(campaign.targets || []).slice(0, 3).map((target, index) => (
                        <div key={`${campaign.id}-target-${index}`}>{target}</div>
                      ))}
                      {(campaign.targets || []).length > 3 ? (
                        <div>… อีก {campaign.targets.length - 3} รายการ</div>
                      ) : null}
                    </td>
                    <td>
                      {campaign.summary
                        ? `${campaign.summary.succeeded}/${campaign.summary.total}`
                        : "-"}
                    </td>
                    <td>{campaign.createdBy || "-"}</td>
                    <td>
                      {campaign.status === "SCHEDULED"
                        ? formatDate(campaign.scheduledAt)
                        : formatDate(campaign.createdAt)}
                    </td>
                    <td>
                      <button
                        type="button"
                        className="push-list-link"
                        onClick={() => SETxDetail(campaign)}
                      >
                        ดู JSON
                      </button>
                      <button
                        type="button"
                        className="push-list-link"
                        onClick={() =>
                          history.push({
                            pathname: "/PushNoti_Compose",
                            state: { campaign }
                          })
                        }
                      >
                        ใช้ซ้ำ
                      </button>
                      <button
                        type="button"
                        className="push-list-link danger"
                        onClick={() => SETxDeleteId(campaign.id)}
                      >
                        ลบ
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {oDetail ? (
        <div className="push-list-overlay" onClick={() => SETxDetail(null)}>
          <div className="push-list-detail" onClick={event => event.stopPropagation()}>
            <div className="push-list-detail-header">
              <h3>{oDetail.name}</h3>
              <button
                type="button"
                className="push-list-detail-close"
                onClick={() => SETxDetail(null)}
              >
                ปิด
              </button>
            </div>
            <p className="push-list-subtext">
              endpoint: <code>{oDetail.endpoint}</code>
            </p>
            <h4>Body ที่ส่ง (ตัวอย่าง 1 target)</h4>
            <pre>{JSON.stringify(oDetail.payload, null, 2)}</pre>
            {oDetail.results && oDetail.results.length > 0 ? (
              <Fragment>
                <h4>ผลการส่งรายเป้าหมาย</h4>
                <ul className="push-list-results">
                  {oDetail.results.map((result, index) => (
                    <li key={`result-${index}`} className={result.ok ? "ok" : "fail"}>
                      {result.target.label} — {result.ok ? "สำเร็จ" : "ล้มเหลว"}
                      {result.message ? `: ${result.message}` : ""}
                    </li>
                  ))}
                </ul>
              </Fragment>
            ) : null}
          </div>
        </div>
      ) : null}

      <WarningModal
        show={oDeleteId !== null}
        onHide={() => SETxDeleteId(null)}
        onHandleGo={() => {
          DELPushNotiCampaign(oDeleteId);
          SETxDeleteId(null);
        }}
        onHandleCancel={() => SETxDeleteId(null)}
        type={"Disapprove"}
        status={"1"}
        title={"ลบแคมเปญนี้ออกจากประวัติหรือไม่?"}
      />
    </Fragment>
  );
}

const withConnect = connect(
  state => ({
    ...state.pushNotiListReducer
  }),
  {
    REQPushNotiList,
    DELPushNotiCampaign,
    CleanUpPushNotiList
  }
);

export default compose(
  withConnect,
  withRouter
)(PushNotiList);
